import { isChromeIos } from '../../../helpers/browserCheck';
import { initViewHeight } from '../../../helpers/view-height';

const CLOSE_TRIGGER = 'data-modal-close';

class Modal {
  constructor(id, options = {}) {
    this.id = id;
    this.options = options;
    this.node = document.getElementById(this.id);
    if (!this.node) return;
    this.contentWrapper = this.node.querySelector('[data-modal="content-wrapper"]');
    this.content = this.node.querySelector('[data-modal="content"]');

    this.render();
  }

  render() {
    if (isChromeIos()) {
      this.node.classList.add('-no-transitions');
      this.contentWrapper.classList.add('-no-transitions');
    }
    if (this.options.controlledFirstRender) {
      return;
    }

    if (this.options.request) {
      this.options.request().then((response) => {
        if (this.options.onResponse) this.options.onResponse(response, this.content);
        this.show();
      });
    } else {
      this.show();
    }
  }

  show = () => {
    this.bodyScrollPosition = window.pageYOffset;
    document.documentElement.style.setProperty('--body-scroll-position', `-${this.bodyScrollPosition}px`);
    this.addEventListeners();
    if (this.options.onShow) this.options.onShow(this.content);
    this.node.classList.add('-opened');
    this.contentWrapper.classList.add('-opened');
  };

  close = () => {
    this.removeEventListeners();
    if (this.options.onClose) this.options.onClose(this.content);
    this.node.classList.remove('-opened');
    this.contentWrapper.classList.remove('-opened');
    window.scrollTo(0, this.bodyScrollPosition);
  };

  addEventListeners = () => {
    document.addEventListener('keydown', this.onKeydown);
    document.body.classList.add('UIModal-no-scroll');
    if (!isChromeIos()) {
      document.documentElement.classList.add('UIModal-no-scroll');
      initViewHeight();
    }
    // prevent modal from closing on desktop, while moving clicked mouse inside modal to outside
    this.node.addEventListener(window.isMobile ? 'click' : 'mousedown', this.onClick);
  };

  removeEventListeners = () => {
    document.removeEventListener('keydown', this.onKeydown);
    document.body.classList.remove('UIModal-no-scroll');
    if (!isChromeIos()) {
      document.documentElement.classList.remove('UIModal-no-scroll');
      initViewHeight();
    }
    // prevent modal from closing on desktop, while moving clicked mouse inside modal to outside
    this.node.removeEventListener(window.isMobile ? 'click' : 'mousedown', this.onClick);
  };

  onClick = (event) => {
    if (event.target.hasAttribute(CLOSE_TRIGGER)) {
      event.stopPropagation();
      event.preventDefault();
      this.close(event);
    }
  };

  onKeydown = (event) => {
    if (event.keyCode === 27) {
      // esc
      this.close();
    }
  };

  updateModal = (id, additionalParams = {}) => {
    let requestId = id;
    if (id) {
      const idFromModalIds = Object.keys(this.options.modalIds).find((key) => {
        return this.options.modalIds[key].id === id;
      })
      this.currentIndex = idFromModalIds
        ? Number(idFromModalIds)
        : this.currentIndex; // don't update index, when modal opened from PlanMap
    } else {
      requestId = this.options.modalIds[this.currentIndex].id;
    }

    this.options.request(requestId).then((response) => {
      this.options.onUpdate(this.currentIndex, response, additionalParams);
    });
  };
}

export const initModalPopstate = (modal) => {
  window.onpopstate = (event) => {
    /* avoid modal close when switching between canvas modes in PlanModal */
    if (event.isTrusted && modal?.node.classList.contains('-opened')) {
      modal.close();
    }
  };
};

export default Modal;
